import { render, staticRenderFns } from "./luckdrawhint_new.vue?vue&type=template&id=1b07ec07&scoped=true&"
import script from "./luckdrawhint_new.vue?vue&type=script&lang=js&"
export * from "./luckdrawhint_new.vue?vue&type=script&lang=js&"
import style0 from "./luckdrawhint_new.vue?vue&type=style&index=0&id=1b07ec07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07ec07",
  null
  
)

export default component.exports